import { render } from "./AlertToast.vue?vue&type=template&id=79fcf6c9"
import script from "./AlertToast.vue?vue&type=script&lang=js"
export * from "./AlertToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__